import { STATUS_SUCCESS } from '@/constants/appConstants';
import AgentService from '@/services/agentService';
import SupervisorService from '@/services/supervisorService';
import BusinessProcessService from '@/services/businessProcessService';
import { BP_HEALTH_THRESHOLDS } from '@/constants/businessProcess/constants';

const socketEventActions = {
  SOCKET_EVENT_AGENT_BP_ASSIGNMENT_CHANGED_EVENT({ dispatch, rootGetters }, event) {
    if (event.agentId === rootGetters['AGENT/loggedInAgent'].id) {
      dispatch('requestAvailableBusinessProcesses', { refresh: true });
    }
  }
};

const stateActions = {
  requestAvailableBusinessProcesses: ({ commit }, reqParams) => {
    return AgentService.getAvailableBusinessProcesses(reqParams).then(response => {
      if (response.status === STATUS_SUCCESS) {
        const availableBusinessProcesses = response.data.sort((bpA, bpB) => {
          return bpA.name > bpB.name ? 1 : -1;
        });

        commit('setAvailableBusinessProcesses', availableBusinessProcesses);
        // commit('AGENT/setAgentBusinessProcesses', availableBusinessProcesses, { root: true });
      }

      return response;
    });
  },

  requestSupervisedBusinessProcesses: ({ commit, rootGetters }) => {
    return SupervisorService.getSupervisedBusinessProcesses(rootGetters['AGENT/loggedInAgent'].id).then(response => {
      if (response.status === STATUS_SUCCESS) {
        commit('setSupervisedBusinessProcesses', response.data);
      }

      return response;
    });
  },

  requestBusinessProcessHealthConfigurationTemplates: ({ commit }) => {
    return BusinessProcessService.getHealthConfigurationTemplates().then(response => {
      if (response.status === STATUS_SUCCESS) {
        commit('setBusinessProcessHealthConfigurationTemplates', response.data);
      }
      return response;
    });
  },

  requestBusinessProcessHealthConfiguration: ({ commit }, businessProcessId) => {
    const DEFAULT_CONFIGURATION_ID = '5fb6e43b9db6ee29e0b3b305';
    return BusinessProcessService.getHealthConfiguration(businessProcessId)
      .then(response => {
        if (response.status === STATUS_SUCCESS) {
          if (response.data) {
            commit('addBusinessProcessHealthConfiguration', response.data);
          } else {
            BusinessProcessService.addHealthConfiguration(businessProcessId, DEFAULT_CONFIGURATION_ID).then(
              response => {
                commit('addBusinessProcessHealthConfiguration', response.data);
              }
            );
          }
        }
        return response;
      })
      .catch(e => {
        BusinessProcessService.addHealthConfiguration(businessProcessId, DEFAULT_CONFIGURATION_ID).then(response => {
          commit('addBusinessProcessHealthConfiguration', response.data);
          return response;
        });
      });
  },

  requestBusinessProcessHealthThresholds: ({ commit, getters, rootGetters }, businessProcessId) => {
    const supervisorId = rootGetters['AGENT/loggedInAgent'].id;
    return SupervisorService.getBusinessProcessHealthThresholds(supervisorId, businessProcessId).then(response => {
      if (response.status === STATUS_SUCCESS) {
        if (response.data && response.data.length) {
          commit('addBusinessProcessHealthThresholds', response.data);
        }
        if (
          (response.data && !response.data.length) ||
          !getters.getDefaultBusinessProcessHealthThreshold(businessProcessId)
        ) {
          const defaultThresholds = getters.getDefaultBusinessProcessHealthThresholds;
          SupervisorService.addBusinessProcessHealthThresholds(
            supervisorId,
            businessProcessId,
            defaultThresholds,
            BP_HEALTH_THRESHOLDS.defaultName
          ).then(response => {
            commit('addBusinessProcessHealthThreshold', response.data);
          });
        }
      }
      return response;
    });
  },

  addBusinessProcessHealthThresholds: ({ commit, rootGetters }, data) => {
    const supervisorId = rootGetters['AGENT/loggedInAgent'].id;
    return SupervisorService.addBusinessProcessHealthThresholds(
      supervisorId,
      data.businessProcessId,
      data.kpis,
      data.name
    ).then(response => {
      commit('addBusinessProcessHealthThreshold', response.data);
      return response.data;
    });
  },

  updateBusinessProcessHealthThresholds: ({ commit, rootGetters }, data) => {
    const supervisorId = rootGetters['AGENT/loggedInAgent'].id;

    return SupervisorService.updateBusinessProcessHealthThresholds(
      supervisorId,
      data.businessProcessId,
      data.id,
      data.kpis,
      data.name,
      data.active
    ).then(response => {
      commit('updateBusinessProcessHealthThresholds', response.data);
      return response.data;
    });
  },

  deleteBusinessProcessHealthThreshold: ({ commit, rootGetters }, data) => {
    const supervisorId = rootGetters['AGENT/loggedInAgent'].id;

    return SupervisorService.deleteBusinessProcessHealthThreshold(supervisorId, data.businessProcessId, data.id).then(
      () => {
        commit('deleteBusinessProcessHealthThreshold', data.id);
        return data;
      }
    );
  },

  addHealthThresholdsConfigurationToOtherBPs: ({ commit, rootGetters }, data) => {
    const supervisorId = rootGetters['AGENT/loggedInAgent'].id;

    return SupervisorService.addHealthThresholdsConfigurationToOtherBPs(
      supervisorId,
      data.bpHealthThresholds.name,
      data.bpHealthThresholds.kpis,
      data.bpIds
    ).then(response => {
      if (response.data && response.data.length) {
        commit('addBusinessProcessHealthThresholds', response.data);
        return response.data;
      }
    });
  },

  addAndApplyHealthThresholdsConfigurationToOtherBPs: ({ commit, rootGetters }, data) => {
    const supervisorId = rootGetters['AGENT/loggedInAgent'].id;

    return SupervisorService.addAndApplyHealthThresholdsConfigurationToOtherBPs(
      supervisorId,
      data.bpHealthThresholds.name,
      data.bpHealthThresholds.kpis,
      data.bpIds
    ).then(response => {
      if (response.data && response.data.length) {
        commit('disableCurrentActiveHealtThresholds', data.bpIds);
        commit('addBusinessProcessHealthThresholds', response.data);
        return response.data;
      }
    });
  }
};

export default {
  ...stateActions,
  ...socketEventActions
};
